import React from 'react';
import './Demo.css';
import { FaPhone } from 'react-icons/fa';

const Demo = () => {
  return (
    <section className="demo" id="demo">
      <div className="demo-container">
        <div className="demo-cta">
          <div className="cta-content">
            <div className="cta-text">
              <h3>Ready to try it yourself?</h3>
              <p>Book free demo and experience the AI receptionist firsthand</p>
            </div>
            
            
            <div className="cta-phone">
              <div className="phone-wrapper">
                <FaPhone className="phone-icon" />
                <div className="phone-details">
                  <span className="phone-label">Demo Line</span>
                   <a href="tel:8565881302" className="phone-number">856-588-1302</a>
                </div>
              </div>
              
              <div className="cta-buttons">
                <a href="tel:8565881302" className="btn-primary">
                  <FaPhone />
                  Call Now
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Demo;
